import { createRoot } from 'react-dom/client';
import React from 'react';
import { Toaster } from 'react-hot-toast';
import App from './App';
import "./styles.css";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Toaster
      toastOptions={{
        position: "bottom-right",
      }}
    />
    <App />
  </React.StrictMode>
);
